import { useState } from "react";

import { useRouter } from "next/router";

// style
import classes from "./SearchCatalogue.module.scss";

// icons
import { SearchIcon } from "@heroicons/react/outline";

// components
import LazyLoad from "react-lazyload";
import { Loader } from "@/components/loader/Loader";
import { CataloguePagination } from "@/components/cataloguePagination/CataloguePagination";

//Component
import ItemCollection from "@/components/collection/ItemCollection";
import EmptyState from "@/components/empty/EmptyState";

function SearchCatalogue(props) {
  const {
    itemListing,
    getProductList,
    isPageLoading,
    isLoading,
    total,
    totalPages,
    nextToken,
    limit,
    selectedPage,
    searchKeyword,
    setSearchKeyword,
  } = props;
  let router = useRouter();

  const handleOnSearch = async (keyword) => {
    setSearchKeyword(keyword);

    let searchKeyword = keyword;

    if (keyword.length > 0 && keyword) {
      searchKeyword = keyword.toLowerCase();
    }
    handleChangePageFilter(1, searchKeyword);
  };

  if (isPageLoading) {
    return <Loader />;
  }

  const handleChangePageFilter = (pageNum, keyword) => {
    // window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    router.push(
      {
        pathname: "/search",
        query: keyword
          ? { page: pageNum, keyword: keyword }
          : { page: pageNum },
      },
      undefined,
      { shallow: true }
    );
  };

  const handleSelectPage = (pageNum) => {
    handleChangePageFilter(pageNum, searchKeyword);
  };

  const handleBackButton = () => {
    if (selectedPage > 1) {
      handleChangePageFilter(selectedPage - 1, searchKeyword);
    }
  };

  const handleForwardButton = () => {
    if (selectedPage < totalPages) {
      handleChangePageFilter(selectedPage + 1, searchKeyword);
    }
  };

  return (
    <div className={classes.conatainer}>
      <div className="w-full">
        <div className="mt-2.5 mb-5 flex h-12">
          <input
            className="w-[calc(100%-25px)] bg-white py-[5px] px-2.5 outline-none"
            onChange={(e) => handleOnSearch(e.target.value)}
            value={searchKeyword}
            placeholder="Search"
          />
          <button
            aria-label="search"
            className="text-white bg-primary inline-flex items-center justify-center px-2.5 hover:bg-primary-dark"
          >
            <SearchIcon width="24px" height="24px" />
          </button>
        </div>
        {searchKeyword !== "" && (
          <div className="mt-2.5 mb-5 bg-[lightgrey]">
            <span>Search result for {`"${searchKeyword}"`}</span>
          </div>
        )}

        <div className={classes["category-title"]}>
          {searchKeyword !== "" ? "Search results" : "Popular Products"}{" "}
          <span> ({total})</span>
        </div>
        <div>
          {!isLoading && itemListing.length === 0 && (
            <EmptyState title="Oops, no products available" />
          )}
          <LazyLoad height={100} offset={8}>
            <ItemCollection itemListing={itemListing} />
          </LazyLoad>
        </div>
        {totalPages > 0 && (
          <CataloguePagination
            totalPages={totalPages}
            selectedPage={selectedPage}
            handleSelectPage={handleSelectPage}
            handleBackButton={handleBackButton}
            handleForwardButton={handleForwardButton}
            limit={limit}
          />
        )}
      </div>
    </div>
  );
}

export default SearchCatalogue;
